import {
  type AudienceRulesTree,
  type RuleBasedAudience,
} from "features/mediaDataRoom/models";

export const mapAudienceRulesTreeToRulesBasedAudience = (
  { name, sourceRef, filters, combine }: AudienceRulesTree,
  overrideValues: { name?: string; id?: string; createdAt?: string }
): RuleBasedAudience => ({
  combine: combine
    ? combine.map(({ operator, sourceRef, filters }) => ({
        filters: filters ? filters : null,
        operator,
        sourceRef: sourceRef ?? "",
      }))
    : null,
  createdAt: overrideValues?.createdAt ?? new Date().toISOString(),
  filters: filters ?? null,
  id: overrideValues?.id ?? crypto.randomUUID(),
  kind: "rulebased",
  name: overrideValues?.name ?? name,
  sourceRef: sourceRef ?? "",
  status: "ready",
});
